/* eslint-disable */

export default () => {
    const header = document.getElementById('header');
    const panel = header.querySelector('.nav-panel');
    const btn_nav = header.querySelector('.btn-nav');
    const btn_close = header.querySelector('.btn-close');
    const btns_back = panel.querySelectorAll('.btn-back');
    const cursor = header.querySelector('.cursor');
    const main_nav = header.querySelector('.main-nav');
    const solutions = header.querySelector('.solutions');
    const myspace = header.querySelector('.myspace');
    const links = panel.querySelectorAll('.solutions a, .main-nav>li> a, .main-myspace>li a');
    const lis = panel.querySelectorAll('.solutions li, .main-nav>li, .main-myspace>li');
    const links_level0 = panel.querySelectorAll('.hasChild');
    const btn_contact = header.querySelector('.btn-contact');
    const contact_panel = header.querySelector('.contact-panel');

    // cursor
    let isLevel1 = false;
    let liActive;
    lis.forEach(li => {
        const level1 = li.querySelector('.level-1');

        if (li.classList.contains('active')) {
            setTimeout(() => {
                cursor.classList.add('notransition');
                liActive = li;
                cursor.style.left = `${li.offsetLeft}px`;

                if (liActive.classList.contains("last")) {
                    const width = level1 ? level1.offsetWidth : liActive.offsetWidth;
                    cursor.style.left = `${li.offsetLeft - width + liActive.offsetWidth}px`;
                }

                cursor.style.setProperty('--color', `${li.hasAttribute('data-color') ? li.dataset.color : 'var(--color-1)'}`);
                cursor.style.width = `${li.offsetWidth}px`;
            }, 10);
        }

        li.onmouseenter = () => {
            cursor.classList.remove('notransition');
            if (level1) {
                if (isLevel1) {
                    level1.classList.add('doubledelay');
                } else {
                    level1.classList.add('delay');
                }
                isLevel1 = true;
            } else {
                isLevel1 = false;
            }

            const width = level1 ? level1.offsetWidth : li.offsetWidth;
            cursor.style.left = `${li.offsetLeft}px`;

            if (li.classList.contains("last")) {
                cursor.style.left = `${li.offsetLeft - width + li.offsetWidth}px`;
            }

            cursor.style.setProperty('--color', `${li.hasAttribute('data-color') ? li.dataset.color : 'var(--color-1)'}`);

            cursor.style.width = `${width}px`;
        }

        li.onmouseleave = () => {
            if (level1) {
                cursor.classList.add('delay');
                level1.classList.remove('delay', 'doubledelay');
            } else {
                cursor.classList.remove('delay');
            }
        }

    })

    const leave = () => {
        if (isLevel1) {
            cursor.classList.add('delay');
        }
        if (liActive) {
            cursor.style.left = `${liActive.offsetLeft}px`;
            cursor.style.setProperty('--color', `${liActive.hasAttribute('data-color') ? liActive.dataset.color : 'var(--color-1)'}`);
            cursor.style.width = `${liActive.offsetWidth}px`;
        } else {
            cursor.style.width = `0px`;
        }
        setTimeout(() => cursor.classList.remove('delay'), 100)
        isLevel1 = false;
    }
    main_nav.onmouseleave = () => leave();
    solutions.onmouseleave = () => leave();
    myspace.onmouseleave = () => leave();

    const resize = () => {
        if (liActive) {
            cursor.classList.add('notransition');
            cursor.style.left = `${liActive.offsetLeft}px`;
            cursor.style.setProperty('--color', `${liActive.hasAttribute('data-color') ? liActive.dataset.color : 'var(--color-1)'}`);
            cursor.style.width = `${liActive.offsetWidth}px`;
        }
    }

    window.addEventListener('resize', resize);


    // mobile level-1 display
    links_level0.forEach(link => {
        link.onclick = (e) => {
            if (panel.classList.contains('open')) {
                e.preventDefault();
                link.parentNode.querySelector('.level-1').classList.add('active');
            }
        }
    });



    // gestion scroll
    let scrollY = 0;
    let oldscrollY;
    let dir = 0;
    let oldstatus, status = 0;
    let trigger = 130;
    let hide = false;

    const change = () => {
        if (status === 0) {
            hide = false;
            header.classList.remove('hide', 'show', 'trig');
        }
        if (status === 1) {
            header.classList.remove('show');
            if (hide) header.classList.add('hide');
            header.classList.add('trig');
        }
        if (status === 2) {
            hide = true;
            header.classList.remove('hide');
            header.classList.add('show');
        }
    };

    const scroll = () => {
        scrollY = window.pageYOffset;
        dir = oldscrollY - scrollY > 0 ? 1 : 0;
        if (scrollY > trigger) {
            status = dir === 0 ? 1 : 2;
        }
        if (scrollY === 0) status = 0;
        oldstatus !== status && change();
        oldstatus = status;
        oldscrollY = scrollY;
    };

    window.addEventListener('scroll', scroll, { passive: true });

    window.pageYOffset > trigger && header.classList.add('show', 'trig');


    // nav open/close
    const open = () => {
        contact_panel.classList.remove('open');
        document.body.classList.add('hasNav');
        btn_nav.classList.add('active');
        // header.classList.add('open');
        panel.classList.add('open');
        btn_nav.setAttribute('aria-expanded', true);
    }

    const close = () => {
        panel.classList.remove('open');
        btn_nav.classList.remove('active');
        document.body.classList.remove('hasNav');
        btn_nav.setAttribute('aria-expanded', false);

        panel.addEventListener('transitionend', () => {
            header.querySelectorAll('.level-1').forEach(el => el.classList.remove('active'));
        }, { once: true })
    }

    btn_nav.onclick = () => btn_nav.getAttribute('aria-expanded') === 'false' ? open() : close();

    btn_close.onclick = () => {
        contact_panel.classList.remove('open');
        document.body.classList.remove('hasNav');
    }
    // open/close contact panel
    btn_contact.onclick = () => {
        if (contact_panel.classList.contains('open')) {
            contact_panel.classList.remove('open');
            document.body.classList.remove('hasNav');

        } else {
            contact_panel.classList.add('open');
            close();
            document.body.classList.add('hasNav');
        }

    };

    // mobile level-1 close
    btns_back.forEach(btn => {
        btn.onclick = () => {
            btn.closest('.level-1').classList.remove('active');
        }
    });
};